/** Shared SMS consent body (Register + /sms-opt-in). Links appended by callers. */
export const SMS_CONSENT_BODY =
  "I agree to receive CareerMaster account SMS alerts (verification codes and informational messages). Message frequency varies. Message and data rates may apply. Reply STOP to opt out or HELP for help. See our";
